var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./vue-file-base64.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8cd22a78\"}!../../../../vue-loader/lib/template-compiler/preprocessor?raw&engine=jade!../../../../vue-loader/lib/selector?type=template&index=0!./vue-file-base64.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-file-base64/src/js/components/vue-file-base64.vue
// module id = 922
// module chunks = 5